const puzzle = {
  id: "Kn3yls643KRUrov3SFSm",
  name: "Same place, different time",
  rebuses: [
    {
      id: "a41a7074-2729-44c9-b689-82b876c042c8",
      style: {},
      solutionInfo: {
        solvedText: "Nikola Tesla",
        type: "text",
        possibleSolutions: [
          {
            id: "10c208ba-4313-4120-9280-05f502d17a0f",
            value: "Nikola Tesla",
          },
          {
            id: "10c208ba-2222-4120-9280-05f502d17a0f",
            value: "Tesla",
          },
        ],
      },
      clues: [
        {
          clueGroup: 1,
          helperText:
            "Try using a calculator or some online tool to make this calculation.",
          clueValues: [
            {
              type: "text",
              id: "e0624f13-f333-4ca8-8ee6-88e3f02496c7",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              value: "100000 * 0.0001",
            },
          ],
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "d0f2ebeb-66a0-4b91-a4c1-21e481404fe2",
          dependsOn: [],
          solutionInfo: {
            solvedText: "10",
            type: "text",
            possibleSolutions: [
              {
                value: "10",
                id: "f6597823-5ab5-45c0-b6ce-eb6159bf95b0",
              },
            ],
          },
        },
        {
          dependsOn: [],
          clueGroup: 1,
          solutionInfo: {
            solvedText: "July",
            possibleSolutions: [
              {
                id: "be0332f3-bf76-4aba-a597-2c806a39185d",
                value: "July",
              },
            ],
            type: "text",
          },
          clueValues: [
            {
              value: "0onJFTQx.png",
              id: "511b6954-ab1f-4c7a-b998-3f58519e5904",
              type: "image",
              style: {
                width: "calc(50% - 10px)",
              },
              subtext: "",
            },
          ],
          helperText:
            "Icons represent months of the year. You have to figure out which one is the circled one.",
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          id: "739e268b-0a06-4ab4-b060-4e105749834b",
        },
        {
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              type: "text",
              subtext: "",
              id: "ffe59fa5-64ec-45ef-9e15-7fec84b55d8a",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "11101000000",
            },
          ],
          helperText: "This number is written in binary. Which number is it?",
          id: "62b2818b-01d0-4fdd-b5ef-fa67da961cb2",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "c17d8e67-490f-415d-b144-57effd6ee0f2",
                value: "1856",
              },
            ],
            type: "text",
            solvedText: "1856",
          },
          clueGroup: 1,
          subtext: "",
          dependsOn: [],
        },
        {
          dependsOn: [
            {
              value: "62b2818b-01d0-4fdd-b5ef-fa67da961cb2",
              id: "1111-1b34-47bc-b487-9538c026f668",
            },
            {
              value: "739e268b-0a06-4ab4-b060-4e105749834b",
              id: "2222-1b34-47bc-b487-9538c026f668",
            },
            {
              value: "d0f2ebeb-66a0-4b91-a4c1-21e481404fe2",
              id: "3333-1b34-47bc-b487-9538c026f668",
            },
          ],
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              value: "eXGkSm7J.png",
              subtext: "",
              type: "image",
              id: "8a58c659-2dbe-43df-b158-2d085e4029a2",
            },
          ],
          style: {
            width: "calc(33% - 10px)",
            filter: "blur(27px)",
          },
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          subtext: "",
          id: "456354ac-2ce8-423c-b704-5d05fc4211f9",
          clueGroup: 0,
          helperText: "Try to find out who was born on given date.",
        },
      ],
    },
    {
      id: "bc625d6b-ce5b-44c4-a9e0-9c85471d5f6f",
      clues: [
        {
          id: "ef101460-ee67-48aa-9a7d-18658ae22d80",
          dependsOn: [],
          clueValues: [
            {
              value: "GpIkBGqB.png",
              subtext: "",
              id: "3cd9a3d9-63fb-4240-b9c7-4c63f0163167",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "image",
            },
          ],
          helperText: "Which member of the Beatles is the arrow pointing to?",
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(50% - 10px)",
          },
        },
      ],
      solutionInfo: {
        solvedText: "John Lennon",
        possibleSolutions: [
          {
            value: "John Lennon",
            id: "5637b307-fbf5-48b1-813d-42d23e4a3aa8",
          },
          {
            value: "Lennon",
            id: "42cff717-422c-4423-b406-4c9f5ff5b200",
          },
        ],
        type: "text",
      },
      style: {},
    },
    {
      id: "e8d50c30-abce-4fe3-9dc8-dafab1ddf338",
      solutionInfo: {
        possibleSolutions: [
          {
            id: "bd70cb26-68b3-4d9f-9c9f-9f99cf9bec7d",
            value: "Richard Nixon",
          },
          {
            value: "Nixon",
            id: "1c35307e-ba27-43c9-835a-d51d809daec3",
          },
        ],
        type: "text",
        solvedText: "Richard Nixon",
      },
      clues: [
        {
          subtext: "",
          dependsOn: [],
          helperText:
            "Find out which American president is the arrow pointing at.",
          id: "d382cbb9-9d86-4a4f-9460-9ecf0c4c5fce",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              id: "b276a822-e337-45fd-a9e3-4f310021e5ad",
              type: "image",
              value: "lYat40GI.png",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          clueGroup: 0,
        },
      ],
      style: {},
    },
    {
      style: {},
      solutionInfo: {
        type: "text",
        solvedText: "New York",
        possibleSolutions: [
          {
            value: "New York",
            id: "63d0fd6b-88bc-4742-b73f-453aa40e91c1",
          },
        ],
      },
      clues: [
        {
          clueValues: [
            {
              type: "text",
              value: "Nikola Tesla",
              subtext: "7 January 1943",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "09a4e4c9-9976-4189-bf5b-92ca79ec1633",
            },
          ],
          dependsOn: [],
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          style: {
            width: "calc(33% - 10px)",
          },
          helperText: "Death date of Nikola Tesla.",
          subtext: "",
          clueGroup: 0,
          id: "399718be-2529-4fe0-9fda-b7fc8e41267e",
        },
        {
          clueGroup: 0,
          clueValues: [
            {
              id: "08a40ebf-3676-4b9b-848d-e51732254755",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              subtext: "",
              value: "John Lennon",
            },
          ],
          helperText: "Death date of John Lennon.",
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          dependsOn: [],
          subtext: "8 December 1980",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "536b7bef-6fcb-4aa2-a7df-07ae09d779fc",
        },
        {
          dependsOn: [],
          clueValues: [
            {
              type: "text",
              subtext: "22 April 1994",
              id: "28d2b2cc-2fb8-45fb-a1fa-d4421f607921",
              value: "Richard Nixon",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          clueGroup: 0,
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          helperText: "Death date of Richard Nixon.",
          id: "81a9d390-1a2b-4742-8304-e4da1c0d79ea",
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
        },
        {
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          subtext: "",
          clueGroup: 0,
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
          id: "812820b0-1518-4ade-bf65-ac8d891f5ff7",
          clueValues: [
            {
              style: {
                width: "calc(50% - 10px)",
              },
              id: "efeeae04-50d9-4769-843d-b25cdb790f61",
              subtext: "",
              type: "image",
              value: "RL7Vmm5S.png",
            },
          ],
          helperText: "In which city did they die?",
        },
      ],
      id: "76ffeb7b-b2e0-4a5c-843f-4b89cdbdfb89",
    },
  ],
};

export default puzzle;
